import CheckForSave from "./CheckForSave"

export default function UnarchiveCampaign(state, payload){
  const {id} = payload
  state.campaigns.index[id].archived = false;
  return CheckForSave(state)
}